import { PrediggoItem } from "../model/prediggo-item.model";
import { SomArticleItem } from "@app/core/models/article-item.model";

export class PrediggoArticleAdapter {
  private item: PrediggoItem;
  private corporate_route: string;
  private legumiz_route: string;
  private faq_route: string;
  private menu_page_route: string

  constructor(
      item: PrediggoItem,
      corporate_route: string,
      legumiz_route: string,
      faq_route: string,
      menu_page_route: string
  ) {
    this.item = item;
    this.corporate_route = corporate_route;
    this.faq_route = faq_route
    this.legumiz_route = legumiz_route
    this.menu_page_route = menu_page_route
  }

  public adapt(): SomArticleItem {
    return this._parseCommonAttributes();
  }

  private _extractAttributeValueFromPrediggo(attributeName: string): string {
    const attribute = this.item.attributeInfo.find(attr => attr.attributeName === attributeName);
    if (attribute) {
      return attribute.vals[0].label;
    }
  }

  private _parseCommonAttributes(): SomArticleItem {
    const article = new SomArticleItem();
    const prediggoItem = this.item;
    article.id = prediggoItem.sku;
    article.trackingCode = prediggoItem.trackingCode;
    article.title = this._extractAttributeValueFromPrediggo('shortDescription');
    article.category = this._extractAttributeValueFromPrediggo('category')
    article.url = this._buildUrl(article.category)
    article.thumbnailUrl =  this._extractAttributeValueFromPrediggo('thumbnailUrl') || '/assets/images/placeholder.png';
    return article
  }

  private _buildUrl(category: string): string {
    const itemUrl = this._extractAttributeValueFromPrediggo('itemUrl');
    const idPage = this._extractAttributeValueFromPrediggo('idPage');
    const dupplicationIdPage = this._extractAttributeValueFromPrediggo('duplicationId');
    switch (category) {
      case 'corporate_article':
        return `/${itemUrl}/${idPage}/${dupplicationIdPage}`;
      case 'faq_entity':
        return `/${this.faq_route}${itemUrl}`;
      case 'magazine_article':
        return `/${this.legumiz_route}/${itemUrl}/${idPage}/${dupplicationIdPage}`;
      case 'menu_article':
        return `/${this.menu_page_route}/${itemUrl}/${idPage}/${dupplicationIdPage}`;
    }
  }
}
  